var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[_c('v-logo',{staticClass:"layout__logo",attrs:{"component":"div"}}),_c('div',{staticClass:"content"},[_c('router-view')],1),_c('footer',{staticClass:"footer"},[_vm._v("\n    © "+_vm._s(_vm.years)+" AENGIX S.L.\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }